<app-breadcrumbs></app-breadcrumbs>

<h1>
  {{ collection?.name }}
</h1>

<div class="row">
  <div class="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-md-8 col-md-offset-2">
    <app-gallery-searchbar [fieldSize]="'medium'"></app-gallery-searchbar>
  </div>
</div>

<div class="row">
  <div class="col-xs-6 col-sm-3" *ngFor="let item of collection?.categories; let i = index">
    <nb-card
      accent="primary"
      class="gallery-landing-card"
      routerLink="/gallery/collection/{{ collectionId }}/category/{{ item }}"
    >
      <nb-card-header>
        <span class="gallery-landing-thumbnail">
          {{ CATEGORIES[item.toUpperCase()]?.name }}
        </span>
      </nb-card-header>
      <nb-card-body>
        <img [src]="categoryThumbnails.get(item)" />
      </nb-card-body>
    </nb-card>
  </div>
</div>
